import { render } from "./contentList.vue?vue&type=template&id=5c3c8685"
import script from "./contentList.vue?vue&type=script&lang=js"
export * from "./contentList.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__